import type {
  GetNotificationsParams,
  NotificationDataSource,
} from '~/api/data-source/notification';
import { notificationDataSource } from '~/api/data-source/notification';
import type { NotificationList } from '~/api/model';
import { notificationListSchema, parseModel } from '~/api/model';

// ============================================================================
// Repository Interface & Implementation
// ============================================================================

export interface NotificationRepository {
  /** 알림 목록 조회 */
  getNotifications(params: GetNotificationsParams): Promise<NotificationList>;
}

export class NotificationRepositoryImpl implements NotificationRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: NotificationDataSource = notificationDataSource,
  ) {}

  async getNotifications(params: GetNotificationsParams) {
    const response = await this.dataSource.getNotifications(params);
    return parseModel(notificationListSchema, response, 'NotificationList');
  }
}

export const notificationRepository = new NotificationRepositoryImpl();
